var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { lock, unlock } from 'tua-body-scroll-lock';
import dynamicPoster from "@bilibili/pc-dynamic-post";
import { report, request, cookie, openQuickLogin } from '@plat-components/utils2';
import biliActEvents from '@bilibili/bili-act-events';
import QRCode from 'qrcode';
import '../css/share-pc.css';
import { openShareWindow, setChannelKey, protoShare, protocolReg, popTips, } from './common';
var dynamicInstance;
var appkey = {
    weibo: '2841902482',
    qqweibo: '84435a83a11c484881aba8548c6e7340'
};
export function share2biliDynamic(config) {
    var formattedConfig = protoShare(config);
    function getBiliUrl() {
        var biliShare = {
            type: 2048,
            repost_code: 20000,
            default_input: encodeURIComponent(formattedConfig.defaultInput || '')
        };
        var sketch = {
            title: formattedConfig.title,
            desc_text: formattedConfig.desc,
            biz_type: formattedConfig.biz_type,
            cover_url: formattedConfig.pics,
            target_url: setChannelKey(formattedConfig.link, 'bili')
        };
        var str = '';
        for (var i in biliShare) {
            str = str + (i + "=" + biliShare[i] + "&");
        }
        str = str + "sketch=" + encodeURIComponent(JSON.stringify(sketch));
        return "https://t.bilibili.com/share/card/index?" + str;
    }
    var handleIFrameMessage = function (event) {
        var _a;
        if (event.data === 'dynamicShareClose') {
            window.removeEventListener('message', handleIFrameMessage, false);
            var iframeWrapper = document.querySelector('.bili-iframe-wrap');
            if (iframeWrapper) {
                unlock();
                (_a = iframeWrapper.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(iframeWrapper);
            }
        }
        else if (event.data === 'dynamic-share-succeed') {
            report('dynamic-share-succeed');
            if (typeof formattedConfig.onDynamicShareSucceed === 'function') {
                formattedConfig.onDynamicShareSucceed();
            }
        }
    };
    var url = getBiliUrl();
    var div = document.createElement('div');
    div.className = 'bili-wrap bili-iframe-wrap';
    var iframeDiv = "<iframe src=" + url + " frameborder=\"0\" width=\"610\" height=\"425\" style=\"position: fixed; top: 50%; left: 50%; margin-top: -214.5px; margin-left: -305px; z-index: 1000;\" id=\"bili-modal\"></iframe>";
    div.innerHTML = iframeDiv;
    document.body.appendChild(div);
    lock();
    window.addEventListener('message', handleIFrameMessage, false);
}
export function share2biliDynamicTypeImage(config) {
    if (!dynamicInstance) {
        dynamicInstance = dynamicPoster({
            image: protocolReg(config.image),
            descPre: config.descPre
        }, undefined, config.callback);
    }
    dynamicInstance.show({
        image: protocolReg(config.image),
        descPre: config.descPre
    }, config.callback);
}
export function share2weibo(config) {
    var formattedConfig = protoShare(config);
    var obj = {
        url: setChannelKey(formattedConfig.link, 'weibo'),
        type: '3',
        count: '1',
        appkey: appkey.weibo,
        title: formattedConfig.desc,
        pic: formattedConfig.pics,
        searchPic: 'false',
        ralateUid: '',
        language: 'zh_cn',
        rnd: new Date().valueOf()
    };
    openShareWindow('https://service.weibo.com/share/share.php?', obj);
}
export function share2qq(config) {
    var formattedConfig = protoShare(config);
    var obj = {
        url: setChannelKey(formattedConfig.link, 'qq'),
        desc: formattedConfig.desc,
        title: formattedConfig.title,
        summary: formattedConfig.desc,
        pics: formattedConfig.pics,
        flash: '',
        site: '',
        style: '201',
        width: 32,
        height: 32
    };
    openShareWindow('https://connect.qq.com/widget/shareqq/index.html?', obj);
}
export function share2qzone(config) {
    var formattedConfig = protoShare(config);
    var obj = {
        url: setChannelKey(formattedConfig.link, 'qzone'),
        showcount: 1,
        desc: formattedConfig.desc,
        summary: formattedConfig.desc,
        title: formattedConfig.title,
        site: '哔哩哔哩',
        pics: formattedConfig.pics,
        style: '203',
        width: 98,
        height: 22
    };
    openShareWindow('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?', obj);
}
export function share2tieba(config) {
    var formattedConfig = protoShare(config);
    var obj = {
        title: formattedConfig.title,
        url: setChannelKey(formattedConfig.link, 'baidu_tieba'),
        uid: 726865,
        to: 'tieba',
        type: 'text',
        relateUid: '',
        pic: formattedConfig.pics.replace('https', 'http'),
        key: '',
        sign: 'on',
        desc: '',
        comment: formattedConfig.desc
    };
    openShareWindow('https://tieba.baidu.com/f/commit/share/openShareApi?', obj);
}
function ShareInit(config, $el, callback) {
    var toShare = {
        title: document.title || '哔哩哔哩弹幕视频网',
        pics: 'https://static.hdslb.com/mobile/img/app_logo.png',
        desc: '哔哩哔哩弹幕视频网 - ( ゜- ゜)つロ  乾杯~ ',
        link: window.location.href,
        shortTitle: document.title,
        searchPic: 'false',
        defaultInput: '',
        favId: 0,
        biz_type: 3,
        onDynamicShareSucceed: function () { }
    };
    this.config = __assign(__assign({}, toShare), protoShare(config));
    this.$el = $el;
    this.callback = callback;
    this.isFav = false;
    this.isLogin = false;
    this.getLoginURL = 'https://api.bilibili.com/x/web-interface/nav';
    this.userFavURL =
        'https://api.bilibili.com/x/v2/fav/topic/favoured?allow_origin=true&cross_domain=true&tpid=';
    this.favData = {
        allow_origin: true,
        cross_domain: true,
        tpid: ''
    };
}
ShareInit.prototype = {
    constructor: ShareInit,
    init: function () {
        this.witchVersion();
    },
    witchVersion: function () {
        if (this.config.show) {
            this.createSingelDom();
        }
        else {
            this.createShareDom();
        }
    },
    getQRcode: function () {
        var _this = this;
        var initQRCode = function () {
            var qrCodeDom = _this.$el.getElementsByClassName('qr-code')[0];
            if (qrCodeDom) {
                var text = setChannelKey(_this.config.link, 'weixin');
                QRCode.toDataURL(text, {
                    width: 120,
                    margin: 0,
                    errorCorrectionLevel: 'M',
                })
                    .then(function (url) {
                    var img = document.createElement('img');
                    img.src = url;
                    qrCodeDom.appendChild(img);
                })
                    .catch(function (err) {
                    console.error(err);
                });
            }
        };
        initQRCode();
        this.shareReport();
    },
    shareReport: function () {
        var _this = this;
        var hoverScript = document.createElement('script');
        var dom = null;
        setTimeout(function () {
            dom = _this.$el.getElementsByClassName('icon_wechat')[0];
        }, 0);
        hoverScript.text = "\n    var c = " + dom + ";\n    if (c) {\n      c.onmouseenter = function(e) {\n        window.reportMsgObj &&\n          window.reportObserver &&\n          ((window.reportMsgObj['share_' + c.dataset ? c.dataset.way : 'default'] = 1),\n          window.reportObserver.forceCommit());\n      }\n      \n      c.onmouseleave = function(e) {\n        return false;\n      }\n    }\n  ";
        this.$el.appendChild(hoverScript);
    },
    bindClick: function () {
        var _this = this;
        var share = this.$el.getElementsByClassName('shareIcon')[0];
        share.addEventListener('click', function (e) {
            var className = (e || event).target.attributes['data-way'];
            if (className) {
                report("share_" + className.value);
                _this.linkToShare(className.value);
                biliActEvents.emit("CLICK_SHARE_PC", className.value);
                if (typeof _this.callback === 'function') {
                    _this.callback(className.value);
                }
            }
        });
    },
    clickFavorite: function () {
        var _this = this;
        var $fav = this.$el.getElementsByClassName('icon-fav')[0];
        if (!this.isLogin) {
            popTips('请先登陆～', $fav, this.$el);
            return;
        }
        else {
            var url = this.isFav
                ? 'https://api.bilibili.com/x/v2/fav/topic/del'
                : 'https://api.bilibili.com/x/v2/fav/topic/add';
            request({
                method: 'post',
                url: url,
                data: {
                    allow_origin: true,
                    cross_domain: true,
                    tpid: this.config.favId,
                    csrf: cookie.getCookie('bili_jct')
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(function () {
                popTips(_this.isFav ? '取消成功!' : '收藏成功!', $fav, _this.$el);
                _this.isFav = !_this.isFav;
                _this.favStateChange();
            })
                .catch(function (error) {
                error.code == -101
                    ? popTips('请登录后收藏～', $fav, _this.$el)
                    : popTips('系统错误，请稍后重试!', $fav, _this.$el);
            });
        }
    },
    favStateChange: function () {
        var title = this.$el.getElementsByClassName('fav')[0];
        var icons = this.$el.getElementsByClassName('icon-fav')[0];
        var arr = icons.className.split(' ').slice(1);
        title.innerHTML = this.isFav ? '已收藏' : '收藏';
        arr.unshift(this.isFav ? 'icon-liked' : 'icon-like');
        icons.setAttribute('class', arr.toString().replace(/,/g, ' '));
    },
    linkToShare: function (type) {
        switch (type) {
            case 'bili':
                this.openMiniLogin();
                break;
            case 'weibo':
                share2weibo(this.config);
                break;
            case 'qq':
                share2qq(this.config);
                break;
            case 'qzone':
                share2qzone(this.config);
                break;
            case 'baidu_tieba':
                share2tieba(this.config);
                break;
            default:
        }
    },
    openMiniLogin: function () {
        var _this = this;
        request({
            method: 'get',
            url: this.getLoginURL
        })
            .then(function (res) {
            if (res.data.isLogin === false) {
                openQuickLogin();
            }
            else if (_this.config.dynamic) {
                share2biliDynamicTypeImage(_this.config.dynamic);
            }
            else {
                share2biliDynamic(_this.config);
            }
        })
            .catch(function () {
            openQuickLogin();
        });
    },
    createShareDom: function () {
        var html = "<div class=\"bili-share-pc bili-clearfix\">\n                  <div class=\"share bili-clearfix fl\">\n                    <div class=\"title fl\">\u5206\u4EAB</div>\n                    <ul class=\"fl shareIcon\">\n                      <li class=\"icon icon_bili\" data-way=\"bili\"></li>\n                      <li class=\"icon icon_weibo\" data-way=\"weibo\"></li>\n                      <li class=\"icon icon_wechat\" data-way=\"wechat\">\n                        <div class=\"weixin-hover\">\n                          <div class=\"qr-before\"></div>\n                          <div class=\"share-weixin-qr\">\n                            <h4>\u5FAE\u4FE1\u626B\u4E00\u626B\u5206\u4EAB</h4>\n                            <div class=\"qr-code\"></div>\n                          </div>\n                        </div>\n                      </li>\n                      <li class=\"icon icon_qzone\" data-way=\"qzone\"></li>\n                      <li class=\"icon icon_qq\" data-way=\"qq\"></li>\n                      <li class=\"icon icon_baidu\" data-way=\"baidu_tieba\"></li>\n                    </ul>\n                  </div>\n                  <div class=\"bili-favoried-icon\"></div>\n                </div>";
        this.$el.innerHTML = html;
        this.getQRcode();
        this.haveFavorite();
        this.bindClick();
    },
    haveFavorite: function () {
        var _this = this;
        if (this.config.favId == 0) {
            return '';
        }
        else {
            request({
                method: 'get',
                url: this.getLoginURL
            })
                .then(function (res) {
                if (res.data.isLogin) {
                    _this.isLogin = true;
                    _this.getFavStatus();
                }
                else {
                    _this.isFav = false;
                    _this.favDom();
                }
            })
                .catch(function () {
                _this.isFav = false;
                _this.favDom();
            });
        }
    },
    getFavStatus: function () {
        var _this = this;
        request({
            method: 'get',
            url: this.userFavURL + this.config.favId
        })
            .then(function (res) {
            if (res.code == 0) {
                _this.isFav = res.data.favoured || false;
                _this.favDom();
            }
        })
            .catch(function () {
            _this.isFav = false;
            _this.favDom();
        });
    },
    favDom: function () {
        var _this = this;
        var favorite = "\n    <div class=\"bili-clearfix\">\n      <span class=\"vertical-line fl\"></span>\n      <div class=\"favourite bili-clearfix\">\n        <div class=\"title fl fav\">" + (this.isFav ? '已收藏' : '收藏') + "</div>\n        <div class=\"" + (this.isFav ? 'icon-liked' : 'icon-like') + " icon-fav fl\"></div>\n      </div>\n    </div>\n    ";
        this.$el.querySelector('.bili-favoried-icon').innerHTML = favorite;
        var like = this.$el.getElementsByClassName('icon-fav')[0];
        like.addEventListener('click', function () {
            _this.clickFavorite();
        });
    },
    createSingelDom: function () {
        var html = "<div id=\"biliSharePc\"><ul class=\"fl share shareIcon\">" + this.itemDom() + "</ul></div>";
        this.$el.innerHTML = html;
        this.getQRcode();
        this.bindClick();
    },
    itemDom: function () {
        var html = '';
        var wechatHTML = "\n    <li class=\"icon icon_wechat\" data-way=\"wechat\">\n      <div class=\"weixin-hover icon-hover\">\n        <div class=\"share-weixin-qr\">\n          <h4>\u5FAE\u4FE1\u626B\u4E00\u626B\u5206\u4EAB</h4>\n          <div class=\"qr-code\"></div>\n        </div>\n      </div>\n    </li>";
        this.config.show.map(function (item) {
            return (html =
                html +
                    (item == 'wechat'
                        ? wechatHTML
                        : "<li class=\"icon icon_" + item + "\" data-way=\"" + item + "\"></li>"));
        });
        return html;
    }
};
var biliSharePC = {
    share: function (config, $el, callback) {
        var shareInit = new ShareInit(config, $el, callback);
        shareInit.init();
        return shareInit;
    }
};
window && (window.biliSharePC = biliSharePC);
export default biliSharePC;
